import { IListing, ISite } from '@curbnturf/entities';
import { createAction, props } from '@ngrx/store';

export const init = createAction('[Prefetch] Init');

export const syncOfflineListings = createAction('[Prefetch] Sync Offline Listings');
export const syncOfflineListingsSuccess = createAction(
  '[Prefetch] Sync Offline Listings Success',
  props<{ listings: IListing[] }>(),
);

export const syncOfflineSitesSuccess = createAction(
  '[Prefetch] Sync Offline Sites Success',
  props<{ sites: ISite[] }>(),
);

export const syncOfflineListingsFailed = createAction('[Prefetch] Sync Offline Listings Failed', props<{ error: any }>());
